import React from "react";
import TableCell from "./TableCell";
import TableHeader from "./TableHeader";
import {Spinner} from "react-bootstrap";

interface DataTableProps<T> {
  id: string;
  data: T[];
  columns: {
    id: string;
    header: string;
    width?: string;
    sortEnabled?: boolean;
    render: (item: T, index: number) => React.ReactNode;
  }[];
  isLoading?: boolean;
  handleSort: (column: string) => void;
  sortBy?: string;
  sortOrder?: string;
}

function DataTable<T>({ id, data, columns, isLoading = false, handleSort, sortBy, sortOrder }: DataTableProps<T>) {
  return (
    <div id={`${id}-table`} className="tw-border tw-border-solid tw-border-[#DFE0E6] tw-border-r-2">
      <div id="table-scroll-container" className="table-container" style={{width: '100%', height: 'auto', overflowX: 'auto'}}>
        <table id={`${id}-data-table`} className="tw-bg-[#DFE1E6] tw-w-full tw-table-fixed">
          <thead id={`${id}-table-header`} className="tw-sticky tw-top-0 tw-bg-[#DFE1E6]">
            <tr>
              {columns.map(column => (
                <TableHeader key={column.id} id={column.id} label={column.header} width={column.width} sortEnabled={column.sortEnabled}  handleSort={handleSort} sortBy={sortBy} sortOrder={sortOrder}/>
              ))}
            </tr>
          </thead>
          <tbody id={`${id}-table-body`} className="tw-bg-white tw-divide-y tw-divide-[#F4F5F7]">
            {isLoading ? (
              <tr>
                <td colSpan={columns.length} className="tw-py-8 tw-text-center">
                  <div className="tw-flex tw-justify-center tw-items-center">
                    <Spinner size="sm" />
                  </div>
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="tw-py-8 tw-text-center tw-text-gray-500">
                  No data available
                </td>
              </tr>
            ) : (
              data.map((item, index) => (
                <tr id={`${id}-row-${index}`} key={index}>
                  {columns.map(column => (
                    <TableCell key={column.id} id={column.id} rowIndex={index}>
                      {column.render(item, index)}
                    </TableCell>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default DataTable;